/**
 * CARRUSEL DE TARJETAS — flechas y estado de los extremos
 * =============================================================================
 * El carrusel es scroll nativo con scroll-snap: el navegador ya hace el gesto
 * táctil, el trackpad y la rueda. Este archivo solo agrega:
 *   · las flechas, que empujan el scroll una "página" (el ancho visible)
 *   · el apagado de la flecha cuando ya no hay a dónde ir
 *
 * Sin librerías y sin depender de slick ni Swiper del tema: así el carrusel no se
 * rompe si esas librerías cambian de versión y no pesa nada extra.
 */
(function () {
  'use strict';

  var MARGEN = 2; // px de tolerancia: los navegadores redondean el scrollLeft
  /* Umbral para decidir si SOBRA contenido. Las columnas del grid dan anchos con
     decimales, asi que scrollWidth puede pasarse 1-2px sin que haya nada oculto de
     verdad. Una tarjeta real siempre mide mucho mas que esto. */
  var UMBRAL_DESBORDE = 8;

  function arrancar(raiz) {
    if (raiz.getAttribute('data-cc-listo')) return;
    raiz.setAttribute('data-cc-listo', '1');

    var pista = raiz.querySelector('[data-cc-track]');
    var control = raiz.querySelector('[data-cc-nav]');
    var anterior = raiz.querySelector('[data-cc-prev]');
    var siguiente = raiz.querySelector('[data-cc-next]');
    if (!pista) return;

    function pintarEstado() {
      var fin = pista.scrollWidth - pista.clientWidth;
      var x = pista.scrollLeft;

      /* El control aparece solo si hay tarjetas fuera de vista. Se mide el desborde real
         en vez de contar tarjetas: asi se adapta solo a las tarjetas por vista de cada
         breakpoint, al ancho de la ventana y a cuantos bloques cargo el editor. */
      if (control) control.hidden = fin <= UMBRAL_DESBORDE;

      // Dentro del recorrido, la flecha del extremo se apaga (sin ocultarse).
      if (anterior) anterior.setAttribute('aria-disabled', x <= MARGEN ? 'true' : 'false');
      if (siguiente) siguiente.setAttribute('aria-disabled', x >= fin - MARGEN ? 'true' : 'false');
    }

    function mover(direccion) {
      // Una página = el ancho visible. Se resta un poco para que la tarjeta del
      // borde quede a la vista y se entienda que la fila sigue.
      var paso = Math.max(pista.clientWidth - 40, 120);
      pista.scrollBy({ left: direccion * paso, behavior: 'smooth' });
    }

    if (anterior) anterior.addEventListener('click', function () { mover(-1); });
    if (siguiente) siguiente.addEventListener('click', function () { mover(1); });

    pista.addEventListener('scroll', pintarEstado, { passive: true });
    window.addEventListener('resize', pintarEstado);

    // Las imágenes cambian el ancho de la pista al cargar: se recalcula.
    if ('ResizeObserver' in window) {
      new ResizeObserver(pintarEstado).observe(pista);
    }

    /* Medicion GA4: el clic en una tarjeta se manda como select_promotion. Antes esto lo
       hacia assets/landing.js; se trajo aca para que la seccion no dependa de otro
       archivo y pueda vivir sola. */
    raiz.addEventListener('click', function (e) {
      var tarjeta = e.target.closest('[data-cc-promo]');
      if (!tarjeta) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_promotion',
        promotion: {
          promotion_name: tarjeta.getAttribute('data-cc-promo-name') || '',
          creative_name: tarjeta.getAttribute('data-cc-creative') || 'carrusel-tarjetas',
          creative_slot: tarjeta.getAttribute('data-cc-position') || '',
          promotion_id: tarjeta.getAttribute('data-cc-id') || '',
          location_id: window.location.pathname
        }
      });
    });

    pintarEstado();
  }

  function iniciar() {
    var carruseles = document.querySelectorAll('[data-cc-carousel]');
    [].forEach.call(carruseles, arrancar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor re-renderiza la sección al cambiar un setting.
  document.addEventListener('shopify:section:load', iniciar);
})();
